import { render, staticRenderFns } from "./AddQuacks.vue?vue&type=template&id=046eda88"
import script from "./AddQuacks.vue?vue&type=script&lang=js"
export * from "./AddQuacks.vue?vue&type=script&lang=js"
import style0 from "./AddQuacks.vue?vue&type=style&index=0&id=046eda88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports